(function () {
  var PDFJS_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174';
  var MIN_SCALE = 0.75;
  var MAX_SCALE = 3;
  var SCALE_STEP = 0.2;

  function getPdfjs() {
    return window.pdfjsLib || window['pdfjs-dist/build/pdf'];
  }

  function configurePdfjs() {
    var pdfjs = getPdfjs();
    if (!pdfjs || pdfjs.__splashConfigured) return pdfjs;

    pdfjs.GlobalWorkerOptions.workerSrc = PDFJS_CDN + '/pdf.worker.min.js';
    pdfjs.__splashConfigured = true;
    return pdfjs;
  }

  function isRenderCancelled(error) {
    return (
      error &&
      (error.name === 'RenderingCancelledException' || error.message === 'Rendering cancelled')
    );
  }

  function initSection(section) {
    if (!section || section.dataset.splashPdfBound === 'true') return;

    var lightbox = section.querySelector('[data-splash-pdf-lightbox]');
    if (!lightbox) return;

    section.dataset.splashPdfBound = 'true';

    var dialog = lightbox.querySelector('[data-splash-pdf-dialog]');
    var stage = lightbox.querySelector('[data-splash-pdf-stage]');
    var pages = lightbox.querySelector('[data-splash-pdf-pages]');
    var status = lightbox.querySelector('[data-splash-pdf-status]');
    var zoomIn = lightbox.querySelector('[data-splash-pdf-zoom-in]');
    var zoomOut = lightbox.querySelector('[data-splash-pdf-zoom-out]');
    var lastTrigger = null;
    var pdfDoc = null;
    var scale = 1;
    var fitScale = 1;
    var renderToken = 0;
    var activeRenderTasks = [];

    function getStageWidth() {
      return Math.max(stage.clientWidth, 280);
    }

    function setPagesLayoutMode(mode) {
      if (!pages) return;

      pages.classList.toggle('splash-pdf-lightbox__pages--zoomed', mode === 'zoomed');
    }

    function applyCanvasDisplaySize(canvas, viewport) {
      if (Math.abs(scale - fitScale) < 0.01) {
        canvas.style.width = '100%';
        canvas.style.height = 'auto';
        return 'fit';
      }

      canvas.style.width = Math.floor(viewport.width) + 'px';
      canvas.style.height = Math.floor(viewport.height) + 'px';
      return scale > fitScale ? 'zoomed' : 'fit';
    }

    function setStatus(message, visible) {
      if (!status) return;
      status.textContent = message;
      status.hidden = !visible;
    }

    function setZoomControls() {
      var minScale = Math.min(MIN_SCALE, fitScale * 0.75);
      if (zoomOut) zoomOut.disabled = scale <= minScale + 0.001;
      if (zoomIn) zoomIn.disabled = scale >= MAX_SCALE - 0.001;
    }

    function cancelActiveRenders() {
      while (activeRenderTasks.length) {
        var task = activeRenderTasks.pop();

        try {
          task.cancel();
        } catch (error) {}
      }
    }

    function getScrollRatio(element) {
      var maxScrollLeft = element.scrollWidth - element.clientWidth;
      var maxScrollTop = element.scrollHeight - element.clientHeight;

      return {
        x: maxScrollLeft > 0 ? element.scrollLeft / maxScrollLeft : 0,
        y: maxScrollTop > 0 ? element.scrollTop / maxScrollTop : 0
      };
    }

    function restoreScrollRatio(element, scrollRatio) {
      var maxScrollLeft = element.scrollWidth - element.clientWidth;
      var maxScrollTop = element.scrollHeight - element.clientHeight;

      if (maxScrollLeft > 0) {
        element.scrollLeft = scrollRatio.x * maxScrollLeft;
      }

      if (maxScrollTop > 0) {
        element.scrollTop = scrollRatio.y * maxScrollTop;
      }
    }

    async function renderPages(showLoading) {
      if (!pdfDoc || !pages || !stage) return;

      cancelActiveRenders();

      var token = ++renderToken;
      var scrollRatio = getScrollRatio(stage);

      pages.innerHTML = '';
      setPagesLayoutMode('fit');

      if (showLoading) {
        setStatus('Loading menu…', true);
      }

      try {
        var layoutMode = 'fit';

        for (var pageNumber = 1; pageNumber <= pdfDoc.numPages; pageNumber += 1) {
          if (token !== renderToken) return;

          var page = await pdfDoc.getPage(pageNumber);
          if (token !== renderToken) return;

          var viewport = page.getViewport({ scale: scale });
          var canvas = document.createElement('canvas');
          var context = canvas.getContext('2d');
          var outputScale = window.devicePixelRatio || 1;

          canvas.width = Math.floor(viewport.width * outputScale);
          canvas.height = Math.floor(viewport.height * outputScale);
          canvas.className = 'splash-pdf-lightbox__page';

          var pageLayoutMode = applyCanvasDisplaySize(canvas, viewport);
          if (pageLayoutMode === 'zoomed') {
            layoutMode = 'zoomed';
          }

          pages.appendChild(canvas);

          var renderTask = page.render({
            canvasContext: context,
            viewport: viewport,
            transform: outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null
          });

          activeRenderTasks.push(renderTask);

          await renderTask.promise;

          activeRenderTasks = activeRenderTasks.filter(function (task) {
            return task !== renderTask;
          });

          if (token !== renderToken) return;
        }

        if (token === renderToken) {
          setPagesLayoutMode(layoutMode);
          setStatus('', false);
          restoreScrollRatio(stage, scrollRatio);
        }
      } catch (error) {
        if (isRenderCancelled(error) || token !== renderToken) return;

        setStatus('Unable to render this menu PDF.', true);
      }
    }

    async function loadPdf(url) {
      var pdfjs = configurePdfjs();
      if (!pdfjs) {
        setStatus('Unable to load menu viewer.', true);
        return;
      }

      cancelActiveRenders();
      renderToken += 1;
      pdfDoc = null;
      pages.innerHTML = '';
      setStatus('Loading menu…', true);

      try {
        var loadingTask = pdfjs.getDocument(url);
        pdfDoc = await loadingTask.promise;

        var firstPage = await pdfDoc.getPage(1);
        var baseViewport = firstPage.getViewport({ scale: 1 });

        fitScale = getStageWidth() / baseViewport.width;
        scale = Math.min(fitScale, MAX_SCALE);

        setZoomControls();
        await renderPages(true);
      } catch (error) {
        setStatus('Unable to load this menu PDF.', true);
      }
    }

    function open(url, title, trigger) {
      if (!url) return;

      lastTrigger = trigger || null;
      lightbox.hidden = false;
      document.body.classList.add('splash-pdf-lightbox-open');

      if (title && dialog) {
        dialog.setAttribute('aria-label', title);
      }

      window.requestAnimationFrame(function () {
        if (dialog) dialog.focus();

        window.requestAnimationFrame(function () {
          loadPdf(url);
        });
      });
    }

    function close() {
      cancelActiveRenders();
      renderToken += 1;
      pdfDoc = null;
      lightbox.hidden = true;
      pages.innerHTML = '';
      setStatus('', false);
      document.body.classList.remove('splash-pdf-lightbox-open');

      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    section.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-splash-pdf-open]');
      if (openButton && section.contains(openButton)) {
        event.preventDefault();
        open(openButton.getAttribute('data-pdf-url'), openButton.getAttribute('data-pdf-title'), openButton);
        return;
      }

      if (event.target.closest('[data-splash-pdf-close]')) {
        event.preventDefault();
        close();
      }
    });

    if (zoomIn) {
      zoomIn.addEventListener('click', function () {
        if (!pdfDoc || scale >= MAX_SCALE) return;
        scale = Math.min(scale + SCALE_STEP, MAX_SCALE);
        setZoomControls();
        renderPages(false);
      });
    }

    if (zoomOut) {
      zoomOut.addEventListener('click', function () {
        if (!pdfDoc) return;

        var minScale = Math.min(MIN_SCALE, fitScale * 0.75);
        if (scale <= minScale) return;

        var nextScale = scale - SCALE_STEP;

        if (scale > fitScale && nextScale < fitScale) {
          scale = fitScale;
        } else {
          scale = Math.max(nextScale, minScale);
        }

        setZoomControls();
        renderPages(false);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (!section.contains(lightbox)) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[id^="SplashPage-"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[id^="SplashPage-"]');
    if (section) {
      delete section.dataset.splashPdfBound;
      initSection(section);
    }
  });
})();
